import { initCacheInvalidatorRegister } from '../cacheRegisterConstructor';

export enum InspectionsCacheEvents {
  UPDATE = 'UPDATE',
}

interface CacheParams {
  projectId?: string;
}

const cacheRegister = initCacheInvalidatorRegister<
  typeof InspectionsCacheEvents,
  CacheParams
>(InspectionsCacheEvents);

export const invalidateInspectionsCache = cacheRegister.invalidate;
export const inspectionsCacheRegister = cacheRegister.register;
